import taylor from "../../../src/images/profile-team17/taylor.png";
import elizabeth from "../../../src/images/profile-team17/elizabeth.png";
import alfredo from "../../../src/images/profile-team17/alfredo.png";
import marvin from "../../../src/images/profile-team17/marvin.png";
import nathan from "../../../src/images/profile-team17/nathan.png";
import stan from "../../../src/images/profile-team17/stan.png";

import emmett from "../../../src/images/profile-team19/emmett.png";
import jeff from "../../../src/images/profile-team19/jeff.png";
import kyle from "../../../src/images/profile-team19/kyle.png";
import luis from "../../../src/images/profile-team19/luis.png";
import mason from "../../../src/images/profile-team19/mason.png";
import micah from "../../../src/images/profile-team19/micah.png";
import richard from "../../../src/images/profile-team19/richard.png";
import ross from "../../../src/images/profile-team19/ross.png";
import mike from "../../../src/images/profile-team19/mike.png";




// Under construction
export const data17 = [
	{ name: 'Elizabeth "Stay Schema(a)innn" Ter Sahakyan', role: 'App Architect, Data Engineer Machine Learning Engineer, UI/UX Designer', href: 'https://github.com/elizabethts', img: elizabeth },
	{ name: 'Alfredo "Wanders through Random Forests" Quintana', role: "Machine Learning Engineer", href: "https://github.com/alqu7095", img: alfredo },
	{
		name: 'Marvin "Starvin for Data Marvin" Davila',
		role: "App Architect, Data Engineer, Assistant UI/UX Designer", href: "https://github.com/malexmad",
		img: marvin
	},
	{
		name: 'Nathan "The Wrangler" Van Wyck', role: "Data Engineer, Machine Learning Engineer", href: "https://www.linkedin.com/in/nathan-van-wyck-48586718a/", img: nathan
	},
	{
		name: 'Taylor "Tailored Databases" Bickell', role: "App Architect, Data Engineer, Assistant UI/UX Designer", href: "https://github.com/tcbic",
		img: taylor
	},
	{
		name: 'Stan "I love it when you call me Big Data" Kusmier', role: "Team Lead", href: "https://github.com/standroidbeta", img: stan
	}
]

export const data19 = [
	{ name: 'Richard Lee Esquivel', role: 'Fullstack Engineer', href: 'https://github.com/RichardEsquivel', img: richard },
	{ name: 'Jeffrey Oliver', role: 'Fullstack Engineer', href: 'https://github.com/codeOfTheFuture', img: jeff },
	{ name: 'Mike Nguyen', role: 'Fullstack Engineer', href: 'https://github.com/mpvn30', img: mike },
	{ name: 'Micah Riley', role: 'Fullstack Engineer', href: 'https://github.com/micahriley88', img: micah },
	{ name: 'Luis Mendes', role: 'Fullstack Engineer', href: 'https://github.com/cvlopes88', img: luis },
	{ name: 'Kyle Haggin', role: 'Data Scientist', href: ' https://github.com/KyleHaggin', img: kyle },
	{ name: 'Ross Fischer', role: 'Data Scientist', href: 'https://github.com/ross-fisher', img: ross },
	{ name: 'Emmett Boudreau', role: 'Data Scientist', href: 'http://github.com/emmettgb', img: emmett },
	{ name: 'Mason Karsevar', role: 'Project Lead', href: 'https://github.com/karsevar', img: mason }
]


